import { Link } from '@chakra-ui/react';
import { ReactNode } from 'react';
import { Link as RouterLink } from 'react-router-dom';

export interface ICustomNavLink {
  to?: string;
  children: ReactNode;
  [x: string]: any;
}

export const CustomNavLink = ({ to, children, ...restProps }: ICustomNavLink) =>
  to ? (
    <Link as={RouterLink} to={to} {...restProps}>
      {children}
    </Link>
  ) : (
    <Link {...restProps}> {children}</Link>
  );
